import { Menu, MenuItem, Sidebar, useProSidebar } from "react-pro-sidebar"
import { Link, useLocation } from "react-router-dom"
import { useGetUserPermissionsQuery } from "user/userService"
import { renderProductsMenu, withCollapsedTooltip } from "./ProductsMenu"
import { RootState } from "store"
import { useSelector } from "react-redux"
import MaintenanceSidebarItem from "modules/Admin/MaintenanceNotification/sidebar/MaintenanceSidebarItem"

export function AppSidebar() {
  const { data: permissions } = useGetUserPermissionsQuery()
  const appRoutes = useSelector((state: RootState) => state.user.appRoutes)

  const { pathname: currentPath } = useLocation()
  const { collapsed } = useProSidebar()

  return (
    <>
      {permissions && (
        <Sidebar className="mm-sidebar">
          <div className="Sidebar_SectionTitle">PRODUCTS</div>
          <Menu closeOnClick={false}>
            {appRoutes &&
              renderProductsMenu({
                currentPath,
                permissions,
                menuItems: appRoutes,
                level: 1,
                collapsed,
              })}
            <MaintenanceSidebarItem />
            {permissions && permissions.includes("read:internal") && (
              <>
                <div className="Sidebar_SectionTitle">INTERNAL</div>
                {withCollapsedTooltip(
                  collapsed,
                  "version",
                  "Version",
                  <MenuItem
                    active={currentPath === "/version"}
                    icon={<i className="ti-target"></i>}
                    component={<Link to="/version" />}
                  >
                    <div>Version</div>
                  </MenuItem>
                )}
                {withCollapsedTooltip(
                  collapsed,
                  "holidays",
                  "Holidays",
                  <MenuItem
                    active={currentPath === "/port-holidays-upload"}
                    icon={<i className="ti-target"></i>}
                    component={<Link to="/port-holidays-upload" />}
                  >
                    <div>Holidays</div>
                  </MenuItem>
                )}
                {withCollapsedTooltip(
                  collapsed,
                  "pp-backtest",
                  "PP Backtest",
                  <MenuItem
                    active={currentPath === "/portpredictor-backtest"}
                    icon={<i className="ti-target"></i>}
                    component={<Link to="/portpredictor-backtest" />}
                  >
                    <div>PP Backtest</div>
                  </MenuItem>
                )}
              </>
            )}
          </Menu>
        </Sidebar>
      )}
    </>
  )
}
